<template>
  <a-modal
    :visible="visible"
    wrap-class-name="sitmap-modal"
    :title="config.title"
    :width="config.width"
    :mask-closable="false"
    @cancel="close()"
  >
    <div class="cont">
      <div>
        <a-spin :indicator="indicator"  tip="提交中" />
      </div>
      <div class="ant-result">
        <div class="left">
          <p v-for="(item,index) in domain" :key="index">{{item}}</p>
        </div>
        <a-button @click="close()">关闭</a-button>  
      </div>
    </div>
  </a-modal>
</template>
<script>
import API from "../api";
import moment from "moment";
import Vue from "vue";

export default {
  name: "Customer",
  data() {
    return {
      visible: false,
      config: {
        title: "Sitemap生成",
        width: "70%"
      },
      loading: false,
      domain: []
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    open(ids, domain) {
      this.visible = true;
      this.domain = domain;
      this.getData(ids)
    },
    close() {
      this.visible = false;
    },
    getData(ids) {
      let THAT = this;
      THAT.loading = true;
      API.customer.BARCH_CREATE_SITMAP({
        ids: ids
      }).then(res => {
        if (res.data.code == 200) {
          THAT.close()
          THAT.$message.success(res.data.msg);
        }
        THAT.$emit("createSitemapEnds")
      })
    }
  },
};
</script>
<style scoped>
.sitmap-modal .cont {
  text-align: center;
}
.sitmap-modal .cont svg {
  color: #faad14;
} 
.ant-result {
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.ant-result .left p {
  line-height: 1.3;
  margin-bottom: 10px;
}
</style>
<style> 
.sitmap-modal .ant-modal-title {
  text-align: center;
}
.sitmap-modal .ant-modal-close-x {
  display: none;
}
.sitmap-modal .ant-modal-footer {
  display: none;
}
</style>
